<app-modal [isOpen]="isOpen" [className]="'max-w-370 p-6 sm:p-8'" (close)="closeModal()">

    <!-- HEADER -->
    <div class="mb-6 flex items-start justify-between">
        <div>
            <h3 class="text-xl font-semibold text-gray-800 dark:text-white/90">
                {{ isViewMode ? ('Detalle de nota #' + selectedNote?.id) : 'Registrar Nota de Crédito / Débito' }}
            </h3>
            <p class="text-sm text-gray-500">
                {{ isViewMode ? 'Información de la nota registrada.' : 'Selecciona la venta de referencia, el tipo de nota e ingresa los ítems a afectar.' }}
            </p>
        </div>
    </div>

    <div class="grid grid-cols-1 gap-6 lg:grid-cols-5">

        <!-- ========================================================= -->
        <!-- IZQUIERDA (form) -->
        <!-- ========================================================= -->
        <div class="lg:col-span-3 space-y-6">

            <!-- ================= VENTA REFERENCIA ================= -->
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/3">
                <div class="flex items-center justify-between mb-4">
                    <h4 class="text-base font-semibold text-gray-800 dark:text-white/90">
                        Venta / Comprobante de referencia
                    </h4>

                    @if (!isViewMode) {
                    <div class="flex gap-2">
                        <button type="button"
                            class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-600 transition-colors"
                            (click)="openSaleModal()">
                            <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M3.04199 9.37381C3.04199 5.87712 5.87735 3.04218 9.37533 3.04218C12.8733 3.04218 15.7087 5.87712 15.7087 9.37381C15.7087 12.8705 12.8733 15.7055 9.37533 15.7055C5.87735 15.7055 3.04199 12.8705 3.04199 9.37381ZM9.37533 1.54218C5.04926 1.54218 1.54199 5.04835 1.54199 9.37381C1.54199 13.6993 5.04926 17.2055 9.37533 17.2055C11.2676 17.2055 13.0032 16.5346 14.3572 15.4178L17.1773 18.2381C17.4702 18.531 17.945 18.5311 18.2379 18.2382C18.5308 17.9453 18.5309 17.4704 18.238 17.1775L15.4182 14.3575C16.5367 13.0035 17.2087 11.2671 17.2087 9.37381C17.2087 5.04835 13.7014 1.54218 9.37533 1.54218Z"
                                    fill="white" />
                            </svg>
                            Buscar venta
                        </button>
                        <button type="button"
                            class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors"
                            (click)="clearSale()">
                            Limpiar
                        </button>
                    </div>
                    }
                </div>

                <div
                    class="rounded-lg border border-dashed border-gray-300 p-3 text-sm text-gray-600 dark:border-gray-700 dark:text-white/90">
                    @if (isViewMode) {
                    <div>
                        <p class="font-medium text-gray-800 dark:text-white">
                            Doc. referencia:
                            {{ selectedNote?.originalDocument?.series }}-{{ selectedNote?.originalDocument?.sequence }}
                        </p>
                        <p class="text-xs text-gray-500 mt-1">Venta ID: {{ selectedNote?.sale?.id }}</p>
                    </div>
                    } @else if (!selectedSale) {
                    <span>Sin venta seleccionada</span>
                    } @else {
                    <div class="flex items-center justify-between">
                        <div>
                            <p class="font-medium text-gray-800 dark:text-white">{{ getSaleDoc(selectedSale) }}</p>
                            <p class="text-xs text-gray-500 mt-1">{{ getClientName(selectedSale) }}</p>
                        </div>
                        <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">
                            {{ currencySymbol }} {{ selectedSale.totalAmount | number:'1.2-2' }}
                        </span>
                    </div>
                    }
                </div>
            </div>

            <!-- ================= TIPO Y MOTIVO ================= -->
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/3">
                <h4 class="text-base font-semibold text-gray-800 dark:text-white/90 mb-4">Tipo de nota y motivo</h4>

                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">

                    <!-- Tipo de nota -->
                    <div>
                        <app-label>Tipo de nota *</app-label>
                        @if (isViewMode) {
                        <app-input-field type="text"
                            [value]="(selectedNote?.creditDebitNoteType?.noteCategory === 'CREDITO' ? 'NC' : 'ND') + ' - ' + (selectedNote?.creditDebitNoteType?.name ?? '')"
                            [disabled]="true">
                        </app-input-field>
                        } @else {
                        <app-select
                            placeholder="{{ !selectedSale ? 'Primero selecciona una venta' : (loadingNoteTypes ? 'Cargando...' : 'Seleccionar tipo') }}"
                            [options]="noteTypeOptions" [(value)]="selectedNoteTypeCode"
                            (valueChange)="onNoteTypeChange()" [disabled]="!selectedSale || loadingNoteTypes">
                        </app-select>
                        }
                    </div>

                    <!-- Comprobante a generar -->
                    <div>
                        <app-label>Comprobante a generar</app-label>
                        <app-input-field type="text"
                            [value]="isViewMode
                                ? ((selectedNote?.series && selectedNote?.sequence) ? selectedNote!.series + '-' + selectedNote!.sequence : 'Sin emitir')
                                : (formattedDocument || (!selectedSale ? 'Primero selecciona una venta' : (selectedNoteTypeCode ? 'Cargando correlativo...' : 'Selecciona un tipo de nota')))"
                            [disabled]="true">
                        </app-input-field>
                        @if (loadingSeries && !isViewMode) {
                        <p class="text-xs text-gray-400 animate-pulse mt-1">Obteniendo correlativo...</p>
                        }
                    </div>

                </div>

                <!-- Motivo -->
                <div class="mt-4">
                    <app-label>Motivo *</app-label>
                    @if (isViewMode) {
                    <app-input-field type="text" [value]="selectedNote?.reason ?? ''" [disabled]="true">
                    </app-input-field>
                    } @else {
                    <app-text-area [(value)]="reason" [rows]="2"
                        placeholder="Ingresa el motivo de la nota...">
                    </app-text-area>
                    }
                </div>

                <!-- OT IDMH -->
                <div class="mt-4 max-w-xs">
                    <app-label>OT IDMH</app-label>
                    <app-ot-input [(value)]="otNumber" [disabled]="isViewMode"></app-ot-input>
                    @if (!isViewMode) {
                    <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Se precarga con la OT de la venta; puedes cambiarla. Solo números (máx. 6).</p>
                    }
                </div>
            </div>

            <!-- ================= DETALLE ITEMS ================= -->
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/3">

                <div class="flex items-start justify-between mb-1">
                    <h4 class="text-base font-semibold text-gray-800 dark:text-white/90">
                        Detalle de la nota
                    </h4>

                    <!-- Botones solo para tipos de adición manual -->
                    @if (!isViewMode && !isAutoLoadType) {
                    <div class="flex gap-2 flex-wrap justify-end">
                        <button type="button"
                            class="inline-flex items-center gap-1.5 rounded-lg bg-brand-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-600 transition-colors"
                            (click)="openProductModal()">
                            <span class="text-lg leading-none">+</span> Agregar producto
                        </button>

                        <button type="button"
                            class="inline-flex items-center gap-1.5 rounded-lg bg-indigo-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-indigo-600 transition-colors"
                            (click)="openServiceModal()">
                            <span class="text-lg leading-none">+</span> Agregar servicio
                        </button>

                        <button type="button"
                            class="inline-flex items-center gap-1.5 rounded-lg border border-yellow-400 bg-yellow-50 px-3 py-1.5 text-sm font-medium text-yellow-700 hover:bg-yellow-100 dark:bg-yellow-900/20 dark:border-yellow-600 dark:text-yellow-400 transition-colors"
                            (click)="openQuickServiceModal()">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M13 3L4 14h8l-1 7 9-11h-8l1-7z" />
                            </svg>
                            Servicio rápido
                        </button>
                    </div>
                    }
                </div>

                <!-- Banner informativo para C01 / D02 -->
                @if (!isViewMode && isAutoLoadType) {
                <div class="mt-3 mb-4 flex items-start gap-2 rounded-lg px-3 py-2.5 text-sm"
                    [class.bg-amber-50]="isItemsLocked"
                    [class.text-amber-700]="isItemsLocked"
                    [class.dark:bg-amber-900\/20]="isItemsLocked"
                    [class.dark:text-amber-300]="isItemsLocked"
                    [class.bg-blue-50]="!isItemsLocked"
                    [class.text-blue-700]="!isItemsLocked"
                    [class.dark:bg-blue-900\/20]="!isItemsLocked"
                    [class.dark:text-blue-300]="!isItemsLocked">
                    <svg class="shrink-0 mt-0.5 w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10" />
                        <path stroke-linecap="round" d="M12 8v4M12 16h.01" />
                    </svg>
                    <span>
                        @if (isItemsLocked) {
                        Los ítems se cargaron del comprobante y <strong class="font-semibold">no pueden modificarse</strong> (anulación total C01).
                        } @else {
                        Los ítems se cargaron del comprobante. Puedes ajustar la <strong class="font-semibold">cantidad</strong> y el <strong class="font-semibold">descuento</strong> de cada ítem.
                        }
                    </span>
                </div>
                }

                @if (!isViewMode && !isAutoLoadType) {
                <p class="text-xs text-gray-400 mb-4 dark:text-gray-500">
                    Agrega los productos o servicios afectados por esta nota.
                </p>
                }

                <!-- TABLA -->
                <div class="overflow-x-auto rounded-lg">
                    <table class="min-w-full text-sm">

                        <thead class="border-b border-gray-200 dark:border-white/5 bg-gray-50 dark:bg-gray-800/50">
                            <tr class="text-gray-500 dark:text-gray-400">
                                <th class="py-3 px-3 text-left font-medium text-xs uppercase tracking-wider">Tipo</th>
                                <th class="py-3 px-3 text-left font-medium text-xs uppercase tracking-wider">Ítem</th>
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Precio</th>
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Cant.</th>
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Dscto %</th>
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Subtotal</th>
                                @if (!isViewMode && !isAutoLoadType) {
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Acción</th>
                                }
                            </tr>
                        </thead>

                        <tbody class="divide-y divide-gray-100 dark:divide-white/5">

                            @if (items.length === 0) {
                            <tr>
                                <td colspan="7" class="py-8 text-center text-gray-400">
                                    @if (isAutoLoadType && !selectedSale) {
                                    Selecciona una venta para cargar los ítems automáticamente.
                                    } @else {
                                    Aún no hay ítems agregados.
                                    }
                                </td>
                            </tr>
                            }

                            @for (item of items; track $index; let i = $index) {
                            <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/40 transition-colors">

                                <td class="py-3 px-3">
                                    <span class="inline-flex items-center text-xs font-medium px-2.5 py-1 rounded-full"
                                        [class.bg-brand-100]="item.itemType === 'PRODUCTO'"
                                        [class.text-brand-700]="item.itemType === 'PRODUCTO'"
                                        [class.dark:bg-brand-900\/30]="item.itemType === 'PRODUCTO'"
                                        [class.dark:text-brand-300]="item.itemType === 'PRODUCTO'"
                                        [class.bg-indigo-100]="item.itemType === 'SERVICIO'"
                                        [class.text-indigo-700]="item.itemType === 'SERVICIO'"
                                        [class.dark:bg-indigo-900\/30]="item.itemType === 'SERVICIO'"
                                        [class.dark:text-indigo-300]="item.itemType === 'SERVICIO'"
                                        [class.bg-gray-100]="item.itemType === 'PERSONALIZADO'"
                                        [class.text-gray-700]="item.itemType === 'PERSONALIZADO'"
                                        [class.dark:bg-gray-800]="item.itemType === 'PERSONALIZADO'"
                                        [class.dark:text-gray-300]="item.itemType === 'PERSONALIZADO'">
                                        {{ item.itemType }}
                                    </span>
                                </td>

                                <td class="py-3 px-3 font-medium text-gray-800 dark:text-white">
                                    {{ item.description }}
                                </td>

                                <td class="py-3 px-3 text-center text-gray-600 dark:text-gray-400">
                                    @if (!isViewMode && !isItemsLocked && isAutoLoadType) {
                                    <input type="number" min="0" step="0.01"
                                        class="w-24 rounded-lg border border-gray-300 bg-white px-2 py-1 text-center text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white"
                                        [(ngModel)]="item.unitPrice" />
                                    } @else {
                                    {{ currencySymbol }} {{ item.unitPrice | number:'1.2-2' }}
                                    }
                                </td>

                                <!-- Cantidad -->
                                <td class="py-3 px-3 text-center">
                                    @if (!isViewMode && !isItemsLocked) {
                                    <input type="number" min="1" step="1" [(ngModel)]="item.quantity"
                                        class="w-16 rounded-md border border-gray-300 bg-white px-2 py-1 text-center text-sm text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white">
                                    } @else {
                                    <span class="text-gray-600 dark:text-gray-400">{{ item.quantity }}</span>
                                    }
                                </td>

                                <!-- Descuento -->
                                <td class="py-3 px-3 text-center">
                                    @if (!isViewMode && !isItemsLocked && (isAutoLoadType || item.itemType === 'PRODUCTO')) {
                                    <input type="number" min="0" max="100" step="1"
                                        [(ngModel)]="item.discountPercentage"
                                        class="w-16 rounded-md border border-gray-300 bg-white px-2 py-1 text-center text-sm text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white">
                                    } @else {
                                    <span class="text-gray-600 dark:text-gray-400">{{ item.discountPercentage || 0 }}%</span>
                                    }
                                </td>

                                <td class="py-3 px-3 text-center font-semibold text-gray-800 dark:text-white">
                                    {{ currencySymbol }}
                                    {{ item.quantity * item.unitPrice * (1 - (item.discountPercentage || 0) / 100) | number:'1.2-2' }}
                                </td>

                                @if (!isViewMode && !isAutoLoadType) {
                                <td class="py-3 text-center">
                                    <button type="button"
                                        class="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium text-white bg-red-500 hover:bg-red-600 rounded-md transition-colors"
                                        (click)="removeItem(i)">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M14.7223 12.7585C14.7426 12.3448 14.4237 11.9929 14.01 11.9726C13.5963 11.9522 13.2444 12.2711 13.2241 12.6848L12.9999 17.2415C12.9796 17.6552 13.2985 18.0071 13.7122 18.0274C14.1259 18.0478 14.4778 17.7289 14.4981 17.3152L14.7223 12.7585Z"
                                                fill="white" />
                                            <path
                                                d="M9.98802 11.9726C9.5743 11.9929 9.25542 12.3448 9.27577 12.7585L9.49993 17.3152C9.52028 17.7289 9.87216 18.0478 10.2859 18.0274C10.6996 18.0071 11.0185 17.6552 10.9981 17.2415L10.774 12.6848C10.7536 12.2711 10.4017 11.9522 9.98802 11.9726Z"
                                                fill="white" />
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M10.249 2C9.00638 2 7.99902 3.00736 7.99902 4.25V5H5.5C4.25736 5 3.25 6.00736 3.25 7.25C3.25 8.28958 3.95503 9.16449 4.91303 9.42267L5.54076 19.8848C5.61205 21.0729 6.59642 22 7.78672 22H16.2113C17.4016 22 18.386 21.0729 18.4573 19.8848L19.085 9.42267C20.043 9.16449 20.748 8.28958 20.748 7.25C20.748 6.00736 19.7407 5 18.498 5H15.999V4.25C15.999 3.00736 14.9917 2 13.749 2H10.249ZM14.499 5V4.25C14.499 3.83579 14.1632 3.5 13.749 3.5H10.249C9.83481 3.5 9.49902 3.83579 9.49902 4.25V5H14.499ZM5.5 6.5C5.08579 6.5 4.75 6.83579 4.75 7.25C4.75 7.66421 5.08579 8 5.5 8H18.498C18.9123 8 19.248 7.66421 19.248 7.25C19.248 6.83579 18.9123 6.5 18.498 6.5H5.5ZM6.42037 9.5H17.5777L16.96 19.7949C16.9362 20.191 16.6081 20.5 16.2113 20.5H7.78672C7.38995 20.5 7.06183 20.191 7.03807 19.7949L6.42037 9.5Z"
                                                fill="white" />
                                        </svg>
                                        Eliminar
                                    </button>
                                </td>
                                }

                            </tr>
                            }

                        </tbody>
                    </table>
                </div>

            </div>

        </div>

        <!-- ========================================================= -->
        <!-- DERECHA (sidebar) -->
        <!-- ========================================================= -->
        <div class="lg:col-span-2 space-y-4">

            <!-- ══ PDF PREVIEW ══ -->
            @if (safePdfUrl) {
            <div
                class="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-800 dark:bg-white/3">
                <div class="flex items-center justify-between mb-3">
                    <h4 class="text-sm font-semibold text-gray-700 dark:text-white/80">
                        {{ isViewMode ? 'Documento NC/ND' : 'Comprobante de referencia' }}
                    </h4>
                    <a [href]="pdfPreviewUrl" target="_blank"
                        class="inline-flex items-center gap-1 text-xs font-medium text-brand-600 hover:underline dark:text-brand-400">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                        Abrir
                    </a>
                </div>
                <iframe
                    [src]="safePdfUrl"
                    class="w-full rounded-lg border border-gray-200 dark:border-gray-700"
                    style="height: 420px;"
                    title="Vista previa del comprobante">
                </iframe>
            </div>
            }

            <!-- ══ TOTALES ══ -->
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/3">

                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">Totales</h4>

                <div class="space-y-3 text-sm">
                    <div class="flex justify-between dark:text-white/90">
                        <span>Subtotal</span>
                        <span>{{ currencySymbol }}
                            {{ (isViewMode ? (selectedNote?.subtotalAmount ?? 0) : subtotal) | number:'1.2-2' }}</span>
                    </div>
                    <div class="flex justify-between dark:text-white/90">
                        <span>IGV (18%)</span>
                        <span>{{ currencySymbol }} {{ (isViewMode ? (selectedNote?.taxAmount ?? 0) : igv) | number:'1.2-2' }}</span>
                    </div>
                    <div class="flex justify-between border-t pt-3 text-base font-semibold dark:text-white/90">
                        <span>Total</span>
                        <span>{{ currencySymbol }} {{ (isViewMode ? (selectedNote?.totalAmount ?? 0) : total) | number:'1.2-2' }}</span>
                    </div>
                </div>
            </div>

            <!-- ══ COMPROBANTE EMITIDO (modo vista) ══ -->
            @if (isViewMode && selectedNote?.series) {
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/3">
                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">Documento emitido</h4>

                <div class="space-y-3 text-sm">
                    <div class="flex justify-between">
                        <span class="text-gray-500 dark:text-gray-400">Serie / Número</span>
                        <span class="font-semibold text-gray-800 dark:text-white">
                            {{ selectedNote!.series }}-{{ selectedNote!.sequence }}
                        </span>
                    </div>
                    <div class="flex justify-between">
                        <span class="text-gray-500 dark:text-gray-400">Fecha emisión</span>
                        <span class="text-gray-700 dark:text-gray-300">
                            {{ selectedNote!.issueDate | date:'dd/MM/yyyy' }}
                        </span>
                    </div>
                    <div class="flex justify-between items-center">
                        <span class="text-gray-500 dark:text-gray-400">Estado SUNAT</span>
                        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                            [class.bg-green-100]="selectedNote!.status === 'ACEPTADO'"
                            [class.text-green-700]="selectedNote!.status === 'ACEPTADO'"
                            [class.bg-red-100]="selectedNote!.status !== 'ACEPTADO'"
                            [class.text-red-700]="selectedNote!.status !== 'ACEPTADO'">
                            {{ selectedNote!.status }}
                        </span>
                    </div>

                    @if (selectedNote!.sunatMessage) {
                    <div
                        class="rounded-lg bg-gray-50 dark:bg-gray-800/50 p-3 text-xs text-gray-600 dark:text-gray-400 leading-relaxed">
                        <span class="font-medium text-gray-700 dark:text-gray-300">
                            Código {{ selectedNote!.sunatResponseCode }}:
                        </span>
                        {{ selectedNote!.sunatMessage }}
                    </div>
                    }
                </div>
            </div>
            }

        </div>

    </div>

    <!-- FOOTER -->
    <div class="flex items-center justify-end gap-3 mt-8 border-t border-gray-200 dark:border-gray-700 pt-6">

        @if (isViewMode) {
        <button type="button" (click)="closeModal()"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cerrar
        </button>
        } @else {
        <button type="button" (click)="closeModal()"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>

        <button type="button" (click)="submitNote()" [disabled]="isSubmitting"
            class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-brand-500 hover:bg-brand-600 disabled:opacity-50">
            {{ isSubmitting ? 'Registrando…' : 'Registrar nota' }}
        </button>
        }

    </div>

</app-modal>


<!-- ================================================================ -->
<!-- MODAL BUSCAR VENTA DE REFERENCIA -->
<!-- ================================================================ -->
<app-modal [isOpen]="showSaleModal" [className]="'max-w-2xl p-6'" (close)="showSaleModal = false">

    <div class="mb-5">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Buscar venta emitida</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Solo se muestran ventas con comprobante emitido</p>
    </div>

    <!-- BUSCADOR -->
    <div class="mb-4">
        <div class="relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            <input type="text" [(ngModel)]="saleSearchTerm" (input)="searchSales()"
                placeholder="Ej: F001-00000001 / Empresa SAC"
                class="w-full pl-9 pr-4 py-2.5 rounded-lg border border-gray-300 bg-white text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-500"
                autofocus>
        </div>
    </div>

    <!-- RESULTADOS -->
    <div class="max-h-100 overflow-y-auto border border-gray-200 rounded-lg dark:border-gray-700">

        @if (loadingSales) {
        <div class="py-10 text-center text-gray-400">
            <svg class="w-10 h-10 mx-auto mb-2 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <p class="text-sm">Cargando ventas...</p>
        </div>
        } @else if (saleResults.length === 0) {
        <div class="py-10 text-center text-gray-400">
            <p class="text-sm">{{ saleSearchTerm ? 'No se encontraron resultados' : 'Sin ventas emitidas disponibles' }}
            </p>
        </div>
        } @else {
        <div class="divide-y divide-gray-100 dark:divide-gray-700">
            @for (sale of pagedSaleResults; track sale.id) {
            <div class="flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer transition-colors"
                (click)="selectSale(sale)">
                <div class="flex-1 min-w-0">
                    <p class="text-sm font-semibold text-gray-800 dark:text-white truncate">
                        {{ getSaleDoc(sale) }}
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ getClientName(sale) }}</p>
                </div>
                <span class="ml-4 text-sm font-semibold text-gray-700 dark:text-gray-300 whitespace-nowrap">
                    {{ sale.currencyCode === 'USD' ? '$' : 'S/' }} {{ sale.totalAmount | number:'1.2-2' }}
                </span>
            </div>
            }
        </div>
        }

    </div>

    <!-- PAGINACIÓN -->
    @if (saleResults.length > salePageSize) {
    <div class="flex items-center justify-between mt-3 px-1">
        <p class="text-xs text-gray-500 dark:text-gray-400">
            {{ (saleCurrentPage - 1) * salePageSize + 1 }}–{{ salePageEnd }} de {{ saleResults.length }}
        </p>
        <div class="flex gap-1">
            <button type="button" [disabled]="saleCurrentPage === 1" (click)="salePrevPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <span class="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300">{{ saleCurrentPage }} /
                {{ saleTotalPages }}</span>
            <button type="button" [disabled]="saleCurrentPage === saleTotalPages" (click)="saleNextPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>
    }

    <!-- FOOTER -->
    <div class="flex justify-end mt-5 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button type="button" (click)="showSaleModal = false"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>
    </div>

</app-modal>


<!-- ================================================================ -->
<!-- MODAL AGREGAR PRODUCTO -->
<!-- ================================================================ -->
<app-modal [isOpen]="showProductModal" [className]="'max-w-2xl p-6'" (close)="showProductModal = false">

    <div class="mb-5">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Agregar producto</h3>
    </div>

    <div class="mb-4">
        <div class="relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            <input type="text" [(ngModel)]="productSearchTerm" (input)="searchProducts()"
                placeholder="Buscar por SKU, nombre o categoría..."
                class="w-full pl-9 pr-4 py-2.5 rounded-lg border border-gray-300 bg-white text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-500"
                autofocus>
        </div>
    </div>

    <div class="max-h-100 overflow-y-auto border border-gray-200 rounded-lg dark:border-gray-700">

        @if (loadingProducts) {
        <div class="py-10 text-center text-gray-400">
            <svg class="w-10 h-10 mx-auto mb-2 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <p class="text-sm">Cargando productos...</p>
        </div>
        } @else if (productResults.length === 0) {
        <div class="py-10 text-center text-gray-400">
            <p class="text-sm">{{ productSearchTerm ? 'No se encontraron resultados' : 'Sin productos disponibles' }}</p>
        </div>
        } @else {
        <div class="divide-y divide-gray-100 dark:divide-gray-700">
            @for (product of pagedProductResults; track product.id) {
            <div class="flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer transition-colors"
                (click)="addProduct(product)">
                <div class="flex-1 min-w-0">
                    <p class="text-sm font-semibold text-gray-800 dark:text-white truncate">{{ product.name }}</p>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ product.sku }} · {{ product.categoryName }}</p>
                </div>
                <span class="ml-4 text-sm font-semibold text-gray-700 dark:text-gray-300 whitespace-nowrap">
                    {{ currencySymbol }} {{ (isUsd ? (product.salePriceUsd ?? 0) : (product.salePricePen ?? 0)) | number:'1.2-2' }}
                </span>
            </div>
            }
        </div>
        }

    </div>

    @if (productResults.length > productPageSize) {
    <div class="flex items-center justify-between mt-3 px-1">
        <p class="text-xs text-gray-500 dark:text-gray-400">
            {{ (productCurrentPage - 1) * productPageSize + 1 }}–{{ productPageEnd }} de {{ productResults.length }}
        </p>
        <div class="flex gap-1">
            <button type="button" [disabled]="productCurrentPage === 1" (click)="productPrevPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <span class="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300">{{ productCurrentPage }} / {{ productTotalPages }}</span>
            <button type="button" [disabled]="productCurrentPage === productTotalPages" (click)="productNextPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>
    }

    <div class="flex justify-end mt-5 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button type="button" (click)="showProductModal = false"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>
    </div>

</app-modal>


<!-- ================================================================ -->
<!-- MODAL AGREGAR SERVICIO -->
<!-- ================================================================ -->
<app-modal [isOpen]="showServiceModal" [className]="'max-w-2xl p-6'" (close)="showServiceModal = false">

    <div class="mb-5">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Agregar servicio</h3>
    </div>

    <div class="mb-4">
        <div class="relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            <input type="text" [(ngModel)]="serviceSearchTerm" (input)="searchServices()"
                placeholder="Buscar por SKU, nombre o categoría..."
                class="w-full pl-9 pr-4 py-2.5 rounded-lg border border-gray-300 bg-white text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-500"
                autofocus>
        </div>
    </div>

    <div class="max-h-100 overflow-y-auto border border-gray-200 rounded-lg dark:border-gray-700">

        @if (loadingServices) {
        <div class="py-10 text-center text-gray-400">
            <svg class="w-10 h-10 mx-auto mb-2 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <p class="text-sm">Cargando servicios...</p>
        </div>
        } @else if (serviceResults.length === 0) {
        <div class="py-10 text-center text-gray-400">
            <p class="text-sm">{{ serviceSearchTerm ? 'No se encontraron resultados' : 'Sin servicios disponibles' }}</p>
        </div>
        } @else {
        <div class="divide-y divide-gray-100 dark:divide-gray-700">
            @for (service of pagedServiceResults; track service.id) {
            <div class="flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer transition-colors"
                (click)="addService(service)">
                <div class="flex-1 min-w-0">
                    <p class="text-sm font-semibold text-gray-800 dark:text-white truncate">{{ service.name }}</p>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ service.sku }} · {{ service.serviceCategoryName }}</p>
                </div>
                <span class="ml-4 text-sm font-semibold text-gray-700 dark:text-gray-300 whitespace-nowrap">
                    {{ currencySymbol }} {{ (isUsd ? (service.priceUsd ?? 0) : (service.pricePen ?? 0)) | number:'1.2-2' }}
                </span>
            </div>
            }
        </div>
        }

    </div>

    @if (serviceResults.length > servicePageSize) {
    <div class="flex items-center justify-between mt-3 px-1">
        <p class="text-xs text-gray-500 dark:text-gray-400">
            {{ (serviceCurrentPage - 1) * servicePageSize + 1 }}–{{ servicePageEnd }} de {{ serviceResults.length }}
        </p>
        <div class="flex gap-1">
            <button type="button" [disabled]="serviceCurrentPage === 1" (click)="servicePrevPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <span class="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300">{{ serviceCurrentPage }} / {{ serviceTotalPages }}</span>
            <button type="button" [disabled]="serviceCurrentPage === serviceTotalPages" (click)="serviceNextPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>
    }

    <div class="flex justify-end mt-5 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button type="button" (click)="showServiceModal = false"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>
    </div>

</app-modal>


<!-- ================================================================ -->
<!-- MODAL SERVICIO RÁPIDO -->
<!-- ================================================================ -->
<app-modal [isOpen]="showQuickServiceModal" [className]="'max-w-md p-6'" (close)="showQuickServiceModal = false">

    <div class="mb-5">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Servicio rápido</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Agrega un ítem personalizado sin registrar en el catálogo.</p>
    </div>

    <div class="space-y-4">
        <div>
            <app-label>Nombre del servicio *</app-label>
            <app-input-field type="text" [(value)]="quickServiceName" placeholder="Ej: Instalación eléctrica">
            </app-input-field>
        </div>
        <div class="grid grid-cols-2 gap-4">
            <div>
                <app-label>Cantidad *</app-label>
                <app-input-field type="number" [step]="1" min="1" placeholder="1" [(value)]="quickServiceQuantity">
                </app-input-field>
            </div>
            <div>
                <app-label>Precio unitario *</app-label>
                <app-input-field type="number" [(value)]="quickServicePrice" placeholder="0.00">
                </app-input-field>
            </div>
        </div>
    </div>

    <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button type="button" (click)="showQuickServiceModal = false"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>
        <button type="button" (click)="submitQuickService()"
            class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-yellow-500 hover:bg-yellow-600">
            Agregar
        </button>
    </div>

</app-modal>
